module.exports = __webpack_public_path__ + "static/media/linkedin.6ad33ce8.svg";


//////////////////
// WEBPACK FOOTER
// ./public/images/icons/linkedin.svg
// module id = 468
// module chunks = 0